export default __webpack_public_path__ + "static/illustration-content.url-85e77a9f0658155dd01c3b2df4a6258b.svg";